import { TFunction } from "i18next";
import { RequestStatus } from "@/types/request";
import { StaffWithRelations } from "@/services/staffService";
import { Role } from "@/types/user";

export interface StaffPresentationLabels {
  status: string;
  name: string;
  email: string;
  phone: string;
  role: string;
  group: string;
  assignedTasks: string;
  active: string;
  inactive: string;
  staff: string;
}

export function getStaffPresentationLabels(
  t: TFunction,
): StaffPresentationLabels {
  return {
    status: t("staff.table.status"),
    name: t("staff.table.name"),
    email: t("staff.table.email"),
    phone: t("staff.table.phone"),
    role: t("staff.table.role"),
    group: t("staff.table.group"),
    assignedTasks: t("staff.table.assignedTasks"),
    active: t("staff.table.active"),
    inactive: t("staff.table.inactive"),
    staff: t("staff.table.staff"),
  };
}

export function mapStaffToExportRow(
  staff: StaffWithRelations,
  labels: StaffPresentationLabels,
): Record<string, string | number> {
  const name = [staff.firstName, staff.lastName].filter(Boolean).join(" ");
  const position = staff.staff?.position;
  const groups = staff.staff?.userTeams.map(({ team }) => team.name) ?? [];
  const assignedTasks =
    staff.staff?.tasks.filter((task) => task.status !== RequestStatus.DONE)
      .length ?? 0;
  const role =
    staff.role === Role.FRONT_DESK
      ? staff.customRoles
          ?.map((customRole) => customRole.customRoleName)
          .join(", ") || "Frontdesk"
      : labels.staff;
  let status = "";
  if (staff.staff) {
    status = staff.staff.isActive ? labels.active : labels.inactive;
  }

  return {
    [labels.status]: status,
    [labels.name]: position ? `${name}\n${position}` : name,
    [labels.email]: staff.email ?? "",
    [labels.phone]: staff.phone ?? "",
    [labels.role]: role,
    [labels.group]: groups.join(", "),
    [labels.assignedTasks]: assignedTasks,
  };
}
